import { makeStyles } from '@mui/styles';

export const useAnchorMenuStyles = makeStyles(() => ({
  headerItem: {
    overflow: 'initial',
  },
  popup: {
    zIndex: 100,
  },
  popupMenu: {
    padding: 0,
  },
  stretched: {
    flexGrow: 1,
  },
}));
